import React, { useEffect, useState } from "react"
import { useLocation, useNavigate } from "react-router-dom";
import { CoreButton } from "../components/CoreButton";
import { CoreForm } from "../components/CoreForm";
import { CoreInput } from "../components/CoreInput";
import { Expressions, MatchValidation, RegexValidation, RequiredValidation } from "../components/CoreValidations";
import UserService from "../services/userService";
import { to } from "../utils/to";
import { Loader } from "./Loader";

type mode = "requesting" | "requested" | "changing" | "changed";
interface Data {
    password: string;
    confirmation: string,
    email: string
}
export const ChangePassword = () => {

    let history = useNavigate();
    let [data, setData] = useState<Data>({
        password: "",
        confirmation: "",
        email: ""
    });
    let [isProcessing, setIsProcessing] = useState(false);
    let [email, setEmail] = useState("");
    let [token, setToken] = useState("");

    let [status, setStatus] = useState("");
    let [result, setResult] = useState(false);

    let [mode, setMode] = useState<mode>("requesting");
    let search = useLocation().search;




    const init = () => {

        let _token = new URLSearchParams(search).get('token');
        let _email = new URLSearchParams(search).get('email');
        let _mode = new URLSearchParams(search).get('mode') as mode;


        console.log("init", _mode);
        setEmail(_email);
        setToken(_token);

        if (_mode) {
            console.log({ _mode });
            setMode(_mode);
        }

    }

    const handlerReset = () => {

        setData({
            password: "",
            confirmation: "",
            email: ""
        });

        setMode("changing");
    }

    const backToLogin = () => history("/login");

    const requestPasswordToken = async () => {
        setIsProcessing(true);
        setStatus("Solicitando troca de senha...");
        const [error, response] = await to(UserService.requestPasswordToken({ email: data.email }));
        if (error) {
            setStatus("Não foi possível solicitar alteração de senha!");
        }

        if (response) {
            setMode("requested");
            setStatus("Se este e-mail estiver correto, você recebrá um e-mail com instruções para trocar sua senha.");
            setResult(true);
        }
        setIsProcessing(false);

    }
    const requestPasswordChange = async () => {

        setIsProcessing(true);
        setStatus("Alterando sua senha...");

        if (data.password != data.confirmation) {
            setStatus("As senhas não conferem!");
            setResult(false);
            setIsProcessing(false);
            return;
        }

        const [error, success] = await to(UserService.requestPasswordChange({
            password: data.password,
            email: email,
            token: token
        }));

        console.log({ error, success });

        if (error) {
            setResult(false);
            setIsProcessing(false);
            setStatus("Dados inválidos. " + error.message);
            setMode("changed");
            return;
        }

        setStatus("Sua senha foi alterada com sucesso.")
        setIsProcessing(false);
        setResult(true);
        setMode("changed");


    }

    const onValueChange = (event: CoreEventChange) => {
        let name = event.name;
        let value = event.value;



        setData({
            ...data,
            [name]: value
        })



    }

    const getModeTitle = () => {
        switch (mode) {
            case "changed": return "Senha alterada";
            case "changing": return "Crie uma nova senha";
            case "requesting":
            case "requested": return "Solicitar alteração de senha";

            default: return "-";
        }
    }

    useEffect(() => {

        init();
    }, []);




    return (
        <div className="grid grid-flow-row w-full h-full background auto-rows-min p-10 justify-center align-middle">

            <div className="grid grid-flow-row  bg-white min-w-[500px] max-w-[800px] auto-cols-fr align-middle items-center auto-cols- rounded-md p-8 shadow-md">
                <span className="font-medium text-lg justify-self-center p-2">{getModeTitle()}</span>

                {
                    mode == "requesting" &&
                    <CoreForm>
                        <div className="grid grid-flow-row gap-4">
                            <div className="p-2">
                                <span className="text-sm font-light text-gray-800">Informe seu e-mail previamente cadastrado na plataforma.</span>
                            </div>

                            <CoreInput
                                name="email"
                                label="E-mail"
                                group="Dados Pessoais"
                                value={data.email}
                                type="text"
                                onChange={onValueChange}
                                validations={[RequiredValidation]}
                                readOnly={isProcessing}

                            />

                            <CoreButton
                                schema="success"
                                text="Solicitar troca do senha"
                                onClick={requestPasswordToken}
                                disabled={isProcessing}
                            />
                        </div>
                    </CoreForm>
                }

                {
                    mode == "changing" &&

                    <CoreForm>
                        <div className="grid grid-flow-row gap-4">
                            <div className="p-2">
                                <span className="text-xs font-light text-gray-800">E-mail</span>
                                <span className="text-lg font-light text-gray-400"> {email}</span>
                            </div>
                            <div className="p-2 grid grid-flow-row">
                                <span className="text-xs font-normal text-gray-800">Certifique-se de que a senha tenha uma letra maiúsculas.</span>
                                <span className="text-xs font-normal text-gray-800">Certifique-se de que possua pelo menos um caracter especial (!@#$&*)</span>
                                <span className="text-xs font-normal text-gray-800">Certifique-se de que exista pelo menos um número.</span>
                                <span className="text-xs font-normal text-gray-800">Certifique-se de que tenha um tamanho mínimo de 6 caracteres.</span>


                            </div>
                            <CoreInput
                                name="password"
                                label="Nova Senha"
                                group="Dados Pessoais"
                                value={data.password}
                                type="password"
                                onChange={onValueChange}
                                validations={[
                                    RequiredValidation,
                                    RegexValidation(Expressions.STRONG_PASSWORD, "Esta senha não possúi a complexidade mínima...")]}
                                readOnly={isProcessing}

                            />

                            <CoreInput
                                name="confirmation"
                                label="Confirmar Senha"
                                group="Dados Pessoais"
                                value={data.confirmation}
                                type="password"
                                onChange={onValueChange}
                                validations={[
                                    RequiredValidation,
                                    MatchValidation(data.password, "As senhas não são iguais.")
                                ]}
                                validateOnChange={data.password}
                                readOnly={isProcessing}

                            />

                            <CoreButton

                                schema="success"
                                text="Trocar senha"
                                disabled={isProcessing}
                                onClick={requestPasswordChange}
                            />
                        </div>
                    </CoreForm>
                }

                {
                    (mode == "changed" || mode == "requested") &&
                    <div className="grid grid-flow-row gap-4">
                        <span className={`font-light text-lg justify-self-center p-2 ${result ? "text-green-600" : "text-red-500"}`}>{status}</span>
                        <CoreButton
                            kind="outline"
                            schema="info"
                            text="Voltar ao Login "
                            onClick={backToLogin}
                            disabled={isProcessing}
                        />
                    </div>
                }

                <Loader enabled={isProcessing} status={status} />

            </div>
        </div>
    )
}
